module.exports = __webpack_public_path__ + "static/graphik-medium-b3bed846ca65e73d2cf0cf6a3b894631.woff";